import { render, staticRenderFns } from "./teacherManageAdd.vue?vue&type=template&id=62976dc8&scoped=true&"
import script from "./teacherManageAdd.vue?vue&type=script&lang=js&"
export * from "./teacherManageAdd.vue?vue&type=script&lang=js&"
import style0 from "./teacherManageAdd.vue?vue&type=style&index=0&id=62976dc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62976dc8",
  null
  
)

export default component.exports